<template>
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
       <el-tab-pane label="会员设置" name="first"></el-tab-pane>
       <el-tab-pane label="会员升级记录" name="second">
        <!-- 会员设置标签页的红点 -->
        <template #label>
          <span class="tab-label">
            会员升级记录
            <span v-if="is_read" class="unread-dot"></span>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="会员申请" name="apply">
        <!-- 会员设置标签页的红点 -->
        <template #label>
          <span class="tab-label">
            会员申请
            <span v-if="is_readx" class="unread-dot"></span>
          </span>
        </template>
      </el-tab-pane>
    </el-tabs>

    <!--积分设置-->
    <Setting v-if="activeName == 'first'"></Setting>
    <!--积分明细-->
    <Log v-if="activeName == 'second'"></Log>
    <Apply v-if="activeName == 'apply'"></Apply>
  </div>
</template>

<script>
  import Setting from './part/Setting';
  import Apply from  './part/Apply';
  import SupplyApi from '@/api/supply.js';
  import Log from './part/Log';
  export default {
    components: {
      Setting,
      Apply,
      Log
    },
    data() {
      return {
        form: {
          status: 0
        },
        activeName: 'first',
        is_read: false ,// 默认没有未读消息
         is_readx: false
      };
    },
    created(){
        console.log('created生命周期执行'); // 添加日志
      this.getRead()
    },
    methods: {
      getRead(){
        SupplyApi.getRead({
          type:'16'
        }).then(res=>{
          this.is_read = res.data;
        }).catch(error => {
          console.error('获取未读状态失败:', error);
        });
         SupplyApi.getRead({
          type:'17'
        }).then(res=>{
          this.is_readx = res.data;
        }).catch(error => {
          console.error('获取未读状态失败:', error);
        });
      }
    }
  };
</script>

<style scoped>
/* 未读红点样式 */
.unread-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #ff4757;
  border-radius: 50%;
  margin-left: 4px;
  animation: pulse 2s infinite;
}

.tab-label {
  display: inline-flex;
  align-items: center;
  position: relative;
}

/* 脉冲动画 */
@keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* 如果需要更明显的红点样式 */
.unread-dot-lg {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: #ff4757;
  border-radius: 50%;
  margin-left: 4px;
  animation: pulse 1.5s infinite;
  box-shadow: 0 0 0 2px rgba(255, 71, 87, 0.3);
}

/* 调整Element UI标签页样式 */
:deep(.el-tabs__item) {
  position: relative;
}

:deep(.el-tabs__item .tab-label) {
  display: inline-flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/user/setting/index.vue